import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import type { SearchSuggestion } from 'client-site-chrome-ui/components/molecules/SearchSuggestions/types';
import type { TrackingEvent } from 'client-site-chrome-ui/types/tracking';

export const trackSearch = (searchTerm: string) => {
  const trackingEvent: TrackingEvent = {
    event: 'custom_event',
    event_category: 'Header',
    event_action: 'find button search',
    event_label: searchTerm,
  };
  return sendGAEvent(trackingEvent);
};

export const trackRefineSearch = (initialSearchTerm: string, searchTerm: string) => {
  const trackingEvent: TrackingEvent = {
    event: 'custom_event',
    event_category: 'Header',
    event_action: 'refine search',
    event_label: `${initialSearchTerm}:${searchTerm}`,
  };
  return sendGAEvent(trackingEvent);
};

export const createSuggestionSearchEvent = (searchTerm: string, suggestion: SearchSuggestion) => ({
  event: 'custom_event',
  event_category: 'Header',
  event_action: `click suggested ${suggestion.type === 'partner' ? 'partner' : 'search term'}`,
  event_label: `${searchTerm}:${suggestion.name}`,
});

export const trackSuggestionSearch = (searchTerm: string, suggestion: SearchSuggestion) => {
  const trackingEvent: TrackingEvent = createSuggestionSearchEvent(searchTerm, suggestion);

  return sendGAEvent(trackingEvent);
};

export const trackSearchInteraction = () => {
  const trackingEvent: TrackingEvent = {
    event: 'custom_event',
    event_category: 'Header',
    event_action: 'search interaction',
    event_label: '3 characters',
  };
  sendGAEvent(trackingEvent);
};
